/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
/**
 * @module
 * @description
 * Change detection enables data binding in Angular.
 */
var change_detection_1 = require('./change_detection/change_detection');
exports.ChangeDetectionStrategy = change_detection_1.ChangeDetectionStrategy;
exports.ChangeDetectorRef = change_detection_1.ChangeDetectorRef;
exports.CollectionChangeRecord = change_detection_1.CollectionChangeRecord;
exports.DefaultIterableDiffer = change_detection_1.DefaultIterableDiffer;
exports.IterableDiffers = change_detection_1.IterableDiffers;
exports.KeyValueChangeRecord = change_detection_1.KeyValueChangeRecord;
exports.KeyValueDiffers = change_detection_1.KeyValueDiffers;
exports.SimpleChange = change_detection_1.SimpleChange;
exports.WrappedValue = change_detection_1.WrappedValue;
//# sourceMappingURL=change_detection.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/core/src/change_detection.js
 ** module id = 102
 ** module chunks = 2
 **/